import { NgModule } from '@angular/core';
import './hubspot.config';
import { HubspotService } from './hubspot.service';

@NgModule({
    providers: [HubspotService]
})
export class HubspotModule {
    constructor(hubspotService: HubspotService) {
        hubspotService.load();
    }
}
